export default __webpack_public_path__ + "static/media/ic_tab_sell.df785610.svg";